function beersByCategory (beers, types, categoryId) {
  const typesInCategory = types
    .filter(type => type.category === categoryId)
    .map(type => type['.key'])
  return beers.filter(beer => typesInCategory.includes(beer.type))
}

function setKegData (beer) {
  const kegTotalLiters = (() => {
    const kegTotalLitersStr = (beer.kegTotalLiters || '').replace(/,/g, '.')
    const kegTotalLitersNum = Number(kegTotalLitersStr)
    return kegTotalLitersNum
  })()

  const kegRemainingLiters = (() => {
    const kegRemainingStr = (beer.kegRemainingLiters || '').replace(/,/g, '.')
    const kegRemainingNum = Number(kegRemainingStr)
    return kegRemainingNum
  })()

  const kegRemainingFraction = (() => {
    if (kegTotalLiters === NaN || kegRemainingLiters === NaN
      || kegTotalLiters < kegRemainingLiters) {
      return
    }

    return kegRemainingLiters / kegTotalLiters
  })()

  const kegRemainingBeers = (() => {
    return kegRemainingLiters / 0.4
  })()

  return {
    ...beer,
    kegTotalLiters,
    kegRemainingLiters,
    kegRemainingFraction,
    kegRemainingBeers,
  }
}

function compareByRemainingBeers (a, b) {
  if (!a.kegRemainingBeers) {
    return 1
  }

  if (!b.kegRemainingBeers) {
    return -1
  }

  return a.kegRemainingBeers - b.kegRemainingBeers
}

export {
  beersByCategory,
  setKegData,
  compareByRemainingBeers
}



// WEBPACK FOOTER //
// ./src/utils/beer.js